import Dashboard from './Dashboard/Dashboard';

function App() {
  return <Dashboard />;
}

export default App;
